import { render, staticRenderFns } from "./VaultMoveConfirm.vue?vue&type=template&id=cd4df042&scoped=true&"
import script from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
export * from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./VaultMoveConfirm.vue?vue&type=style&index=0&id=cd4df042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4df042",
  null
  
)

export default component.exports